module.exports = __webpack_public_path__ + "static/media/sidebar-5.91187d22.jpg";